import { useState } from 'react';

import { Button, Text } from '@iwoca/orion';
import { FormattedMessage, useIntl } from 'react-intl';

interface AddPhoneNumberFormProps {
    onCancel: () => void;
    onSave: (phoneNumber: string) => void;
    isLoading?: boolean;
}

export const AddPhoneNumberForm = ({
    onCancel,
    onSave,
    isLoading = false
}: AddPhoneNumberFormProps) => {
    const intl = useIntl();
    const [phoneNumber, setPhoneNumber] = useState('');
    const [error, setError] = useState<string | null>(null);

    const handleSave = () => {
        if (!phoneNumber.trim()) {
            setError(
                intl.formatMessage({
                    id: '_.credit_card.onboarding.id_check.phone_number_required',
                    defaultMessage: 'Please enter a phone number'
                })
            );
            return;
        }

        onSave(phoneNumber);
    };

    const handleCancel = () => {
        setPhoneNumber('');
        setError(null);
        onCancel();
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPhoneNumber(e.target.value);
        if (error) {
            setError(null);
        }
    };

    return (
        <div className="col-span-2 flex flex-col gap-xs">
            {error && <Text className="text-error-40 text-xs">{error}</Text>}
            <div className="flex flex-row gap-m">
                <input
                    type="tel"
                    className="fs-exclude flex-1 rounded-m border border-structure-80 px-m py-s"
                    placeholder={intl.formatMessage({
                        id: '_.credit_card.onboarding.id_check.your_phone_number',
                        defaultMessage: 'Your phone number'
                    })}
                    value={phoneNumber}
                    onChange={handleChange}
                    disabled={isLoading}
                />
                <Button
                    onClick={handleSave}
                    disabled={!phoneNumber.trim() || isLoading}
                    className="whitespace-nowrap"
                >
                    <FormattedMessage
                        id="_.credit_card.onboarding.id_check.save"
                        defaultMessage="Save"
                    />
                </Button>
                <button
                    type="button"
                    onClick={handleCancel}
                    disabled={isLoading}
                    className="whitespace-nowrap text-primary-40 hover:underline disabled:text-structure-60"
                >
                    <FormattedMessage
                        id="_.credit_card.onboarding.id_check.cancel"
                        defaultMessage="Cancel"
                    />
                </button>
            </div>
        </div>
    );
};
